import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'cmg-clear2-ui-slide-out-panel',
  templateUrl: './slide-out-panel.component.html',
  styleUrls: ['./slide-out-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [NgClass],
})
export class SlideOutPanelComponent {
  readonly open = input<boolean>(undefined);
  readonly close = input<boolean>(undefined);

  readonly panelOpened = output<boolean>();
  readonly panelClosed = output<boolean>();
}
